/**
 * aresLoader.js. DO NOT apply var to these values. The var.less file has not loaded yet.
 * Created by calhosh on 9/22/2020.
 */

import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

const AresSkeletonLoader = styled.section`
	overflow-y: auto;
	overflow-x: hidden;
	background: transparent;
	display: flex;
	flex-direction: column;
	flex: 1 1 0;
	line-height: 1;
	top: 0;
	position: relative;
	align-items: stretch;
	width: 100%;
	animation: 1.2s ease-in-out 0s infinite normal none running animation-16jpnkj;
	padding: 3rem 12rem 0 12rem !important;
`;

const StyledSkeletonWrapper = styled.section`
	padding: 0 2rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 2rem;
	border: 0.1rem solid ${(props) => props.theme.color[`grey300`]};
	border-radius: 1.2rem;
	span {
		display: inline-flex;
		height: 5rem !important;
		align-items: center;
		&:nth-child(1) {
			width: 50% !important;
			height: 100%;
		}
		&:nth-child(2) {
			width: 10% !important;
			height: 100%;
			padding-left: 2rem;
		}
		&:nth-child(3) {
			width: 10% !important;
			height: 100%;
			padding-left: 2rem;
		}
		&:nth-child(4) {
			width: 10% !important;
			height: 100%;
			padding-left: 2rem;
		}
	}
`;

const AresLoader = () => {
	return (
		<AresSkeletonLoader className="StyledLoaderdiv">
			<StyledSkeletonWrapper className="StyledSkeletonWrapper One">
				<Skeleton circle={false} width={400} height={50} count={1} />
			</StyledSkeletonWrapper>
			<StyledSkeletonWrapper className="StyledSkeletonWrapper Two">
				<Skeleton circle={false} width={700} height={50} count={1} />
				<Skeleton circle={false} width={250} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
			</StyledSkeletonWrapper>
			<StyledSkeletonWrapper className="StyledSkeletonWrapper Three">
				<Skeleton circle={false} width={700} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
			</StyledSkeletonWrapper>
			<StyledSkeletonWrapper className="StyledSkeletonWrapper Four">
				<Skeleton circle={false} width={700} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
			</StyledSkeletonWrapper>
			<StyledSkeletonWrapper className="StyledSkeletonWrapper Five">
				<Skeleton circle={false} width={700} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
			</StyledSkeletonWrapper>
			<StyledSkeletonWrapper className="StyledSkeletonWrapper Six">
				<Skeleton circle={false} width={700} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
				<Skeleton circle={false} width={100} height={50} count={1} />
			</StyledSkeletonWrapper>
		</AresSkeletonLoader>
	);
};

export default AresLoader;
